import type { Tournament, TournamentOfChampions } from '../../../stores/tournament/types';

export type TournamentDialogVariant = 'toc' | 'teams' | 'regular' | null;

/**
 * Which dialog component `TournamentDialog` should render.
 *
 * `tournamentOfChampions` being present doesn't mean `currentTournament` is one of its rounds —
 * `selectPlayerTournament` can (correctly) resolve `currentTournament` to an unrelated, unclaimed
 * regular tournament while the player also has TOC state (2026-08 production incident: exactly
 * this happened, and this routing check — independent of `selectPlayerTournament` — still forced
 * the TOC dialog regardless, so the player never saw their unclaimed regular round at all). Only
 * let TOC claim the dialog slot when there's nothing else to show, or when `currentTournament`
 * genuinely belongs to this bracket, or when TOC still owes a round result over a live race — the store's
 * `ownsCurrentTournamentSlot` (`doesTocHoldTournamentSlot`), passed in so both read one rule.
 */
export const selectTournamentDialogVariant = ({
  currentTournament,
  tournamentOfChampions,
  shouldRenderTocDialog,
  tocOwnsSlot,
}: {
  currentTournament: Tournament | null;
  tournamentOfChampions: TournamentOfChampions | null;
  shouldRenderTocDialog: boolean;
  tocOwnsSlot: boolean;
}): TournamentDialogVariant => {
  if (shouldRenderTocDialog && tournamentOfChampions && tocOwnsSlot) {
    return 'toc';
  }
  if ((tournamentOfChampions && tocOwnsSlot) || !currentTournament) {
    return null;
  }
  if (currentTournament.tournamentGroup.mode === 'teams') {
    return 'teams';
  }
  return 'regular';
};
